import { LoadingButton } from '@mui/lab';
import Paper from '@mui/material/Paper';
import { styled, useTheme } from '@mui/material/styles';
import { Box, Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { LoadingScreen } from 'src/components/loading-screen';
import { enqueueSnackbar } from 'notistack';
import FaqsHero from 'src/sections/faqs/faqs-hero';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
}));

export default function DashboardAnnouncementView() {
  const theme = useTheme();
  const [text, setText] = useState('');

  // const [updateSetting, { isLoading: isUpdating }] = useUpdateSettingMutation();
  // const { data, isLoading } = useGetAboutUsQuery();

  let settingId = data?.data?._id;
  const isLoading = false;

  const handleChange = (value) => {
    setText(value);
  };

  const applyWhiteTextColor = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const elements = doc.body.querySelectorAll("*");
    elements.forEach((el) => {
      el.style.color = "white";
    });
    return doc.body.innerHTML;
  };

  const handleSave = async () => {
    if (!text) {
      return enqueueSnackbar('Please enter content', { variant: "error" });
    }

    // const processedText = applyWhiteTextColor(text);
    try {
      const payload = {
        announcements: text,
      };
      // const response = await updateSetting({ _id: settingId, data: payload }).unwrap();
      // if (!response.error) {
      //   return enqueueSnackbar(response?.message, { variant: "success" });
      // }
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };

  useEffect(() => {
    if (data) {
      setText(data?.data?.announcements || '');
    }
  }, [data]);

  return (
    <>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <FaqsHero data={'Announcements & Updates'} />

          <Stack mt={3}>
            <StyledPaper
              elevation={3}
              sx={{
                ".ql-toolbar": {
                  backgroundColor: theme?.palette.mode === 'dark' ? "#fff" : ""
                }
              }}
            >
              <ReactQuill
                value={text}
                onChange={handleChange}
                modules={{
                  toolbar: [
                    [{ header: '1' }, { header: '2' }, { font: [] }],
                    [{ size: [] }],
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [
                      { list: 'ordered' },
                      { list: 'bullet' },
                      { indent: '-1' },
                      { indent: '+1' },
                    ],
                    ['link', 'image', 'video'],
                    ['clean'],
                  ],
                }}
                formats={[
                  'header',
                  'font',
                  'size',
                  'bold',
                  'italic',
                  'underline',
                  'strike',
                  'blockquote',
                  'list',
                  'bullet',
                  'indent',
                  'link',
                  'image',
                  'video',
                ]}
              />
            </StyledPaper>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <LoadingButton
                onClick={handleSave}
                type="submit"
                color="primary"
                variant="contained"
              >
                Save
              </LoadingButton>
            </Box>
          </Stack>
        </>
      )}
    </>
  );
}

const data = {
  data: {
    announcements: `
      <h1>Announcements & Updates</h1>
      <p>Welcome to our latest platform updates! Here you'll find news about new features, improvements, and scheduled maintenance.</p>

      <h2>New Features</h2>
      <ul>
        <li><strong>Drive Hub Dashboard:</strong> Track all your vehicles and trips in a centralized dashboard.</li>
        <li><strong>Real-Time Notifications:</strong> Stay informed about changes and updates instantly.</li>
        <li><strong>User Profiles:</strong> Enhanced user management with editable profiles and permissions.</li>
      </ul>

      <h2>Improvements</h2>
      <ul>
        <li>Optimized performance for faster loading times.</li>
        <li>Refined search functionality for better results.</li>
        <li>Enhanced mobile responsiveness across all devices.</li>
      </ul>

      <h2>Scheduled Maintenance</h2>
      <p>Our platform will undergo maintenance on <strong>October 20, 2025</strong> from 1:00 AM to 5:00 AM UTC. Services may be temporarily unavailable.</p>

      <h2>Stay Updated</h2>
      <p>We recommend enabling notifications to receive the latest updates directly in your account.</p>
    `
  }
};
